/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricCategory } from './MetricCategory';
import {
    MetricCategoryFromJSON,
    MetricCategoryFromJSONTyped,
    MetricCategoryToJSON,
    MetricCategoryToJSONTyped,
} from './MetricCategory';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface RawMetricRepresentation
 */
export interface RawMetricRepresentation {
    /**
     * 
     * @type {string}
     * @memberof RawMetricRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof RawMetricRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RawMetricRepresentation
     */
    unit: string;
    /**
     * 
     * @type {MetricCategory}
     * @memberof RawMetricRepresentation
     */
    category: MetricCategory;
    /**
     * 
     * @type {Resolution}
     * @memberof RawMetricRepresentation
     */
    resolution: Resolution;
    /**
     * 
     * @type {string}
     * @memberof RawMetricRepresentation
     */
    dataProviderKey: string;
    /**
     * 
     * @type {string}
     * @memberof RawMetricRepresentation
     */
    assignedMetricKey?: string;
}



/**
 * Check if a given object implements the RawMetricRepresentation interface.
 */
export function instanceOfRawMetricRepresentation(value: object): value is RawMetricRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    return true;
}

export function RawMetricRepresentationFromJSON(json: any): RawMetricRepresentation {
    return RawMetricRepresentationFromJSONTyped(json, false);
}

export function RawMetricRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawMetricRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'unit': json['unit'],
        'category': MetricCategoryFromJSON(json['category']),
        'resolution': ResolutionFromJSON(json['resolution']),
        'dataProviderKey': json['dataProviderKey'],
        'assignedMetricKey': json['assignedMetricKey'] == null ? undefined : json['assignedMetricKey'],
    };
}

export function RawMetricRepresentationToJSON(json: any): RawMetricRepresentation {
    return RawMetricRepresentationToJSONTyped(json, false);
}

export function RawMetricRepresentationToJSONTyped(value?: RawMetricRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'unit': value['unit'],
        'category': MetricCategoryToJSON(value['category']),
        'resolution': ResolutionToJSON(value['resolution']),
        'dataProviderKey': value['dataProviderKey'],
        'assignedMetricKey': value['assignedMetricKey'],
    };
}

